export default "__VITE_ASSET__Bq1f10dZ__"